import { render } from "./appCenter.vue?vue&type=template&id=2c6a5030&scoped=true"
import script from "./appCenter.vue?vue&type=script&lang=js"
export * from "./appCenter.vue?vue&type=script&lang=js"

import "./appCenter.vue?vue&type=style&index=0&id=2c6a5030&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c6a5030"]])

export default __exports__